import { type CoreItemCategory } from '@flecto/types'

export function useFlattenCategories(
  categories: CoreItemCategory[]
): CoreItemCategory[] {
  const flatten = (cats: CoreItemCategory[]): CoreItemCategory[] => {
    return cats.flatMap(({ subcategories, ...rest }) => [
      { ...rest, subcategories: subcategories ?? [] },
      ...(subcategories ? flatten(subcategories) : []),
    ])
  }

  return flatten(categories)
}
